// import { report } from "process";
import { dashboardAction, ReportManagements } from "../actionTypes";
const initialState = {
  dashboardData: [],
  branchList: [],
  loader: false,
  transactionReportData: [],
  adminPaymentReportsData: [],
  orderReportData: [],
  productReportData: [],
};

export default function dashboard(state = initialState, { type, payload }) {
  switch (type) {
    case dashboardAction.OWNER_DASHBOARD_INITIATE: {
      return {
        ...state,
        loader: true,
        dashboardData: [],
      };
    }
    case dashboardAction.OWNER_DASHBOARD_SUCCESS: {
      return {
        ...state,
        loader: false,
        dashboardData: payload,
      };
    }
    case dashboardAction.OWNER_DASHBOARD_FAILURE: {
      return {
        ...state,
        loader: false,
        dashboardData: [],
      };
    }

    case dashboardAction.BRANCH_LIST_INITIATE: {
      return {
        ...state,
        loader: true,
        branchList: [],
      };
    }
    case dashboardAction.BRANCH_LIST_SUCCESS: {
      return {
        ...state,
        loader: false,
        branchList: payload,
      };
    }
    case dashboardAction.BRANCH_LIST_FAILURE: {
      return {
        ...state,
        loader: false,
        branchList: [],
      };
    }

    case ReportManagements.TRANSACTION_REPORT_INITIATE: {
      return {
        ...state,
        loader: true,
        transactionReportData: [],
      };
    }
    case ReportManagements.TRANSACTION_REPORT_SUCCESS: {
      return {
        ...state,
        loader: false,
        transactionReportData: payload,
      };
    }
    case ReportManagements.TRANSACTION_REPORT_FAILURE: {
      return {
        ...state,
        loader: false,
        transactionReportData: payload,
      };
    }
    case ReportManagements.ADMIN_PAYMENT_REPORT_INITIATE: {
      return {
        ...state,
        loader: true,
        adminPaymentReportsData: [],
      };
    }
    case ReportManagements.ADMIN_PAYMENT_REPORT_SUCCESS: {
      return {
        ...state,
        loader: false,
        adminPaymentReportsData: payload,
      };
    }
    case ReportManagements.ADMIN_PAYMENT_REPORT_FAILURE: {
      return {
        ...state,
        loader: false,
        adminPaymentReportsData: payload,
      };
    }

    case ReportManagements.ORDER_REPORT_INITIATE: {
      return {
        ...state,
        loader: true,
        orderReportData: [],
      };
    }
    case ReportManagements.ORDER_REPORT_SUCCESS: {
      return {
        ...state,
        loader: false,
        orderReportData: payload,
      };
    }
    case ReportManagements.ORDER_REPORT_FAILURE: {
      return {
        ...state,
        loader: false,
        orderReportData: payload,
      };
    }

    case ReportManagements.PRODUCT_REPORT_INITIATE: {
      return {
        ...state,
        loader: true,
        productReportData: [],
      };
    }
    case ReportManagements.PRODUCT_REPORT_SUCCESS: {
      return {
        ...state,
        loader: false,
        productReportData: payload,
      };
    }
    case ReportManagements.PRODUCT_REPORT_FAILURE: {
      return {
        ...state,
        loader: false,
        productReportData: payload,
      };
    }

    default:
      return state;
  }
}
